import { useEffect } from "react";

const AppRedirect = () => {

  useEffect(() => {

    const userAgent =
      navigator.userAgent || navigator.vendor || window.opera;

    // Android Devices
    if (/android/i.test(userAgent)) {

      window.location.href =
        "https://play.google.com/store/apps/details?id=com.maamaas.movers";

    }

    // iPhone / iPad Devices
    else if (
      /iPad|iPhone|iPod/.test(userAgent) &&
      !window.MSStream
    ) {

      window.location.href =
        "https://apps.apple.com/";

    }

    // Desktop / Other Devices
    else {

      window.location.href =
        "https://play.google.com/store/apps/details?id=com.maamaas.movers";

    }

  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "100px",
        fontFamily: "Arial"
      }}
    >
      <h2>Redirecting...</h2>
      <p>Please wait while we redirect you.</p>
    </div>
  );
};

export default AppRedirect;